<button mat-icon-button aria-label="Login" (click)="loginWithRedirect()" *ngIf="!(isHandset$ | async)">
  Sign Up
</button>

<button mat-icon-button aria-label="Login" (click)="loginWithRedirect()" *ngIf="(isHandset$ | async)">
  <mat-icon>how_to_reg</mat-icon>
</button>
